// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;500;600;700&display=swap);"]);
// Module
exports.push([module.id, ".is-editable[data-v-40cb0ffc]{border-color:transparent!important;border-bottom:1px dotted #000!important;border-radius:0}", ""]);
// Exports
module.exports = exports;
